import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#399EE6', // entity
        secondary: '#959DA6', // UI
        accent: '#55B4D4', // tag
        error: '#F27983', // REMOVED
        info: '#709ECC', // MODIFIED
        success: '#99BF4D', // ADDED
        warning: '#E6BA7E' // SPECIAL,
      },
      dark: {
        primary: '#59C2FF', // entity
        secondary: '#3D424D', // UI
        accent: '#39BAE6', // TAG
        error: '#D96C75', // REMOVED
        info: '#6994BF', // MODIFIED
        success: '#91B362', // ADDED
        warning: '#E6B673' // SPECIAL
      }
    }
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  icons: {
    iconfont: 'md'
  }
})
